<template>
   <div>
      <!-- // récoltes  -->
      <div class="sous-titre">Noms des récoltes</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <form @submit.prevent="valider" v-else>
         <div class="columns container-mobile">
            <div class="column" v-for="(variete, index) in varietes" :key="index">
               <b-field :label="'Récolte n° ' + (index + 1)">
                  <b-input v-model="varietes[index].nom" required></b-input>
               </b-field>
            </div>
         </div>
         <div class="container-mobile"><b-button style="margin-top:25px" icon-left="check" size="is-medium" native-type="submit" type="is-primary" :loading="loading_form">Valider</b-button></div>
      </form>

      <!-- profil  -->
   </div>
</template>

<script>
import axios from 'axios';
import { BeatLoader } from '@saeris/vue-spinners';

export default {
   components: { BeatLoader },
   data() {
      return {
         loading: false,
         loading_form: false,
         varietes: []
      };
   },
   created() {
      this.getParametres();
      this.$store.commit('setTitre', 'Paramètres');
   },
   methods: {
      getParametres() {
         this.loading = true;
         axios.get('/parametres').then(res => {
            this.varietes = res.data;
            this.loading = false;
         });
      },
      valider() {
         this.loading_form = true;
         axios
            .post('/parametres/update', { varietes: this.varietes })
            .then(() => {
               this.loading_form = false;
               this.$buefy.toast.open({
                  message: 'Paramètres mis à jour !',
                  type: 'is-success'
               });
            })
            .catch(() => {
               this.$buefy.toast.open({
                  message: "Une erreur s'est produite, veuillez réessayer ultérieurement",
                  type: 'is-danger'
               });
               this.loading_form = false;
            });
      }
   }
};
</script>

<style></style>
